export default __webpack_public_path__ + "static/media/weather_01.6e4cf386.png";